var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgText(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 5a.75.75 0 000 1.5h14.5a.75.75 0 000-1.5H4.75zm0 4a.75.75 0 000 1.5h14.5a.75.75 0 000-1.5H4.75zM4 13.75a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H4.75a.75.75 0 01-.75-.75zM4.75 17a.75.75 0 000 1.5h8.5a.75.75 0 000-1.5h-8.5z",
    fill: "currentColor"
  })));
}

export default SvgText;